import { useEffect, useState } from 'react';

const useIntersection = (element, rootMargin, threshold, multipleObserve = false) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
        if (entry.isIntersecting && !multipleObserve) {
          if (entry.target) {
            observer.unobserve(entry.target);
          }
        }
      },
      { rootMargin, threshold }
    );

    const el = element?.current;
    if (el) {
      observer.observe(el);
    }

    return () => {
      if (el) {
        observer.unobserve(el);
      }
    };
  }, [element?.current, rootMargin, threshold, multipleObserve]);

  return isVisible;
};

export default useIntersection;

// 1. If element is being observed if element.current is valid
// 2. If isVisible becomes true, if element comes in viewport
// 3. If multipleObserve is false, check if element is unobserved
// 4.
